<template>
  <div class="home">


    <div class="creppy-white-blass-wait">
      <h5 style="padding-top: 20px" class="display-title-strong middle-wave text-white">Server Besitzer Integration</h5>

      <br class="no-move"/>

      <h5 class="smaller-normal-text middle-wave text-white">Verfügbar ab Version<br class="no-move"/>2.5.8</h5>

      <br class="no-move"/>
      <br class="no-move"/>

    </div>

    <div class="main-title">

      <br class="no-move"/>
      <br class="no-move"/>

      <h1 class="headers-text text-dark"><strong>Du besitzt ein Minecraft Netzwerk?</strong></h1>
      <p class="body-title-lighter text-dark"><strong>Dann bist du hier genau richtig. Bestätige uns dies in einfachen
        Schritten wie im unteren Teil erklärt.</strong></p>
      <br class="no-move"/>

      <div class="container">

        <b-img class="img" src="../assets/download.png"/>

        <div class=" white-shadow text-dark">
          <p class="normal-text-secondary text-dark">

            <br class="no-move"/>

            <strong>Vorteile:</strong>
            <br/>
            - Ein Ⓢ für Server hinter deinem NameTag.
            <br/>
            - Spieler können entweder via Befehl mit <i>/lhserver [Dein Name]</i> deinen Server betreten oder sie nutzen
            das Interaktionsmenü.
            <br/>
            - Du bewirbst deinen Server durch das Ⓢ hinter deinem NameTag.
            <br/>

          </p>

        </div>

      </div>

      <div class="white-shadow text-dark">
        <p class="normal-text-secondary text-dark">

          <br class="no-move"/>

          <strong>Maximal drei Server Mitglieder können den Ⓢ Tag für deinem Server beanspruchen.</strong>

        </p>

      </div>

      <br class="no-move"/>

      <div class="orange-blass-wait white-shadow text-dark">
        <br class="no-move"/>

        <h1 class="headers-text text-dark"><strong>Beantragen?</strong></h1>

        <p class="body-title-lighter text-dark">Die 4. Schritt Anleitung zu der LabyHelp Server Integration.</p>

        <br class="no-move"/>

        <div class=" white-shadow text-dark">
          <p class="normal-text-secondary text-dark middle">


            <strong>Alle Punkte müssen für die Bestätigung in der Email erfüllt werden:</strong>
            <br class="no-move"/>
            <br class="no-move"/>
            <strong>1.</strong> In der Email an (<a href="mailto:server@labyhelp.de">server@labyhelp.de</a>) müssen die Spieler Namen der
            maximal drei Team Mitglieder / Vertreter stehen.
            <br class="no-move"/>

            <br class="no-move"/>
            <strong>2.</strong> In der Email muss die Server Adresse stehen sowie die Website URL. (Wenn möglich die Team Seite zu
            Bestätigung.)
            <br class="no-move"/>

            <br class="no-move"/>
            <strong>3.</strong> In der Email muss dein Discord Link stehen und die drei ausgewählten Personen haben einen sichtbaren Rang
            in der Mitglieder Liste.
            <br class="no-move"/>

            <br class="no-move"/>
            <strong>4.</strong> Deine Email Adresse muss entweder von deiner Domain stammen oder du bestätigst uns auf einer anderen
            unkomplizierteren Weise deine Identität.
            <br class="no-move"/>
            <br class="no-move"/>
            <i style="color: #412d14">Zum Beispiel sendest du die Email von der Adresse kontakt@<u>mcone.eu</u> an
              server@labyhelp.de. Wenn dein Minecraft Server "mcone.eu" heißt.</i>
            <br class="no-move"/>
            <br class="no-move"/>
          </p>


        </div>

        <br class="no-move"/>

        <b-button href="mailto:server@labyhelp.de" type="button" class="gray-shadow smaller-end-text"
                  variant="light"><strong>Email senden</strong>
        </b-button>

        <br class="no-move"/>
        <br class="no-move"/>

        <p class="normal-text-secondary text-dark middle">
        <strong>Achtung: Der Server darf sich nicht in Wartungsarbeiten befinden. <br class="no-move"/> Eine Rückantwort erhältst du nach ca. 2-5 Tagen.</strong>
        </p>

        <br class="no-move"/>
        <br class="no-move"/>
        <br class="no-move"/>
        <br class="no-move"/>

      </div>


      <br class="no-move"/>
      <br class="no-move"/>
      <br class="no-move"/>

      <div class="" style="alignment: bottom">

        <div class="" style="alignment: bottom">
          <p class="smaller-end-text">© {{ today.getFullYear() }}
            <a style="color: #6868b3" href="https://labyhelp.de">LabyHelp Group</a> -
            <a style="color: #6868b3"
               href="https://labyhelp.de/support">Support</a>
            -
            <a style="color: #6868b3"
               href="https://labyhelp.de/apply">Apply</a>
            -
            <a style="color: #6868b3"
               href="https://labyhelp.de/creator">Creator</a>
            -
            <a style="color: #6868b3"
               href="ts3server://labyhelp.de">TeamSpeak</a>
          </p>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Privacy",
  data() {
    return {
      today: new Date()
    }
  },
}
</script>

<style scoped>

</style>
